import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { CgMenuHotdog } from "react-icons/cg";

const Header = ({ scrollToAboutUs, scrollToFeature, scrollToHowItWorks, scrollToFAQ ,scrollToContactUs}) => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const offset = window.scrollY;
            if (offset > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    let navbarClasses = ['navChild'];
    if (scrolled) {
        navbarClasses.push('scrolled');
    }

   
    return (
        <div className='NavParent' style={{ position: 'relative' }}>
            <Navbar expand="lg" className={`${navbarClasses.join(' ')} sticky-navbar`}>
                <Container>
                    <Navbar.Brand href="#home" style={{
                        fontFamily: 'Nunito, sans-serif',
                        fontWeight: 'bold',
                        color: '#fff'
                    }}>
                        <img src="/fexperience/assets/video/MainLogo.png" className='img-fluid MainLogo' alt="" />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav">
                        <CgMenuHotdog />
                    </Navbar.Toggle>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ms-auto">
                            <Nav.Link href="/" className='text-black navLinkHover fontWeight-800 mx-2'>Home</Nav.Link>
                            <Nav.Link onClick={scrollToAboutUs} href="/" className='text-black navLinkHover fontWeight-800 mx-2'>About Us</Nav.Link>
                            <Nav.Link onClick={scrollToFeature} href="/" className='text-black navLinkHover fontWeight-800 mx-2'>Features</Nav.Link>
                            <Nav.Link onClick={scrollToHowItWorks} href="/" className='text-black navLinkHover fontWeight-800 mx-2'>How it Works</Nav.Link>
                            <Nav.Link onClick={scrollToFAQ} href="/" className='text-black navLinkHover fontWeight-800 mx-2'>FAQs</Nav.Link>
                            <Button type='submit' variant='primary' onClick={scrollToContactUs} className='GetTouch rounded-5 fontWeight-600 mx-2'>Get In Touch</Button>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    )
}

export default Header;
